/**
 * zIndex scale and application values
 * Use scale and values to determine relative layers of the application.
 * Do not edit zIndex scale. Only add to exported zIndex values.
 * Example Grouping Layers (Update accordingly):
 * zIndex1: screen focus
 * zIndex2: block
 * zIndex3: button
 * zIndex4: nav
 * zIndex5: avatar/logo
 * zIndex6: backdrop
 * zIndex7: modal
 * zIndex8: tooltip
 * zIndex9: popover/dialog/toast
 * zIndex10: dev (overtake all option; should never really be used)
 */

export interface IZIndex {
  readonly [key: string]: number;
}

const scale: IZIndex = {
  zIndexNegative1: -1,
  zIndex1: 100,
  zIndex2: 200,
  zIndex298: 298,
  zIndex299: 299,
  zIndex3: 300,
  zIndex4: 400,
  zIndex5: 500,
  zIndex6: 600,
  zIndex7: 700,
  zIndex8: 800,
  zIndex9: 900,
  zIndex10: 1000,
};

// NOTE: ordered by zIndex value
export const zIndex: IZIndex = {
  homepageHeaderBefore: scale.zIndexNegative1,

  accordionDropdownMenuContent: scale.zIndex1,
  arrowButton: scale.zIndex1,
  auctionStoryOverlay: scale.zIndex1,
  blackFridaySpaceOverlay: scale.zIndex1,
  blackFridayTapToWinLink: scale.zIndex1,
  buyBarGradient: scale.zIndex1,
  checkboxIcon: scale.zIndex1,
  gridCellSizePrice: scale.zIndex1,
  homepageBrandContent: scale.zIndex1,
  homepageTab: scale.zIndex1,
  mobilePdpHeaderGradient: scale.zIndex1,
  mobilePdpThumbnail: scale.zIndex1,
  pdpImage: scale.zIndex1,
  searchPlaceholder: scale.zIndex1,
  window: scale.zIndex1,
  zoomedInRobot: scale.zIndex1,

  actionButton: scale.zIndex2,
  dropdownSelectMenu: scale.zIndex2,
  homepageTabBorderCropper: scale.zIndex2,
  opacityMask: scale.zIndex2,
  pdpHeader: scale.zIndex2,
  pdpWindowFocused: scale.zIndex2,
  robotImage: scale.zIndex2,
  searchSortAndFilters: scale.zIndex2,
  pdpBuyBarVariantView: scale.zIndex2,

  appLandingNav: scale.zIndex3,
  homepageTabButton: scale.zIndex3,
  homepageTabsActive: scale.zIndex3,
  pdpFooter: scale.zIndex3,
  pdpWindowNewlyFocused: scale.zIndex3,
  searchGridHeader: scale.zIndex3,

  brandOverlay: scale.zIndex4,
  footer: scale.zIndex4,
  homepageTabsInactive: scale.zIndex4,
  notificationToaster: scale.zIndex4,
  pdpBuyBar: scale.zIndex4,

  blackFridayLandingFooter: scale.zIndex5,
  customCursor: scale.zIndex5,
  fitFeedbackWindow: scale.zIndex5,
  homepageTabHeader: scale.zIndex5,
  nav: scale.zIndex5,
  pdpFooterItem: scale.zIndex5,
  pdpSiteFooter: scale.zIndex5,
  pdpVariantWindow: scale.zIndex5,
  pdpBuyBarAccordion: scale.zIndex5,

  productDetailPageBuyBarOpen: scale.zIndex6,

  backdrop: scale.zIndex7,
  modal: scale.zIndex7,

  brandPageTab: scale.zIndex9,
  snackbarNotification: scale.zIndex9,

  blockingOverlay: scale.zIndex10,
  dev: scale.zIndex10,
  pageLoader: scale.zIndex10,
  pageOverlay: scale.zIndex10,

  homepageContent: scale.zIndex298,
  homepageGradient: scale.zIndex299,
};
